export default __webpack_public_path__ + "static/logogk-1-822f38056842710b1a920111e67e9c2e.svg";